import { FC } from 'react';
import { classNames } from '../../../utils';

type ProfileIconProps = {
  imgSrc?: string;
  width?: string;
  height?: string;
  className?: string,
};

const ProfileIcon: FC<ProfileIconProps> = ({ imgSrc, height, width, className }) => {
  return imgSrc ? (
    <div
      className={classNames(width ? width : 'w-8 md:w-12', height ? height : 'h-8 md:h-12', className && className)}
    >
      <img
        src={imgSrc}
        alt='Community logo'
        className={classNames(
          width ? width : 'w-8 md:w-12',
          height ? height : 'h-8 md:h-12',
          'rounded-full shadow-sm max-w-full align-middle border-none',
        )}
      />
    </div>
  ) : null;
};

export default ProfileIcon;
